import { LOCAL_EXPIRATION, LOCAL_USER_DATA, REMEMBER_ME_DATA, SELECTED_ORGANIZATION } from '../../constants';

function readAuthData(): {
    initialExpirationDate: Date | null;
    userId: string | undefined;
    email: string | undefined;
    rememberMeData: { user: string; rememberMe: boolean };
} {
    const expirationString = window.localStorage.getItem(LOCAL_EXPIRATION);
    const initialExpirationDate = expirationString ? new Date(expirationString) : null;
    const userData = JSON.parse(window.localStorage.getItem(LOCAL_USER_DATA) || '{}') as {
        user?: string;
        userId?: string;
    };
    const rememberMeData = JSON.parse(window.localStorage.getItem(REMEMBER_ME_DATA) || '{}') as {
        user: string;
        rememberMe: boolean;
    };
    return {
        initialExpirationDate,
        userId: userData.userId,
        email: userData.user,
        rememberMeData: rememberMeData,
    };
}

function saveTokenExpiration(expiration: Date): void {
    window.localStorage.setItem(LOCAL_EXPIRATION, expiration.toUTCString());
}

function saveAuthCredentials(user: string, userId: string): void {
    const userData = {
        user: user,
        userId: userId,
    };
    window.localStorage.setItem(LOCAL_USER_DATA, JSON.stringify(userData));
}
function saveRememberMeData(user: string, rememberMe: boolean): void {
    const RememberMeData = {
        user: user,
        rememberMe: rememberMe,
    };
    window.localStorage.setItem(REMEMBER_ME_DATA, JSON.stringify(RememberMeData));
}
function clearAuthCredentials(): void {
    window.localStorage.removeItem(LOCAL_EXPIRATION);
    window.localStorage.removeItem(LOCAL_USER_DATA);
}
function clearRememberMeData(): void {
    window.localStorage.removeItem(REMEMBER_ME_DATA);
}
function clearSelectedOrganization(): void {
    window.localStorage.removeItem(SELECTED_ORGANIZATION);
}
export const LocalStorage = {
    readAuthData,
    saveAuthCredentials,
    saveRememberMeData,
    clearAuthCredentials,
    saveTokenExpiration,
    clearRememberMeData,
    clearSelectedOrganization,
};
